/**
 * Excel download names for the three finance surfaces (#178).
 *
 * Shape: `{surface}_{from}_{to}.xlsx`. When both ends share a year the
 * end date drops the year (`请求日志_2026-09-01_09-05.xlsx`); a span
 * that crosses a year keeps both full dates. No calendar window
 * (billing, today) uses `_全部`.
 */
export function exportFilename(
  surface: string,
  fromDay: string | null,
  toDay: string | null,
): string {
  if (fromDay === null || toDay === null) {
    return `${surface}_全部.xlsx`;
  }
  const toPart = fromDay.slice(0, 4) === toDay.slice(0, 4) ? toDay.slice(5) : toDay;
  return `${surface}_${fromDay}_${toPart}.xlsx`;
}
